import React from 'react';
import MultiSelectDropdown from './MultiSelectDropdown';
import { ICONS, defaultExpiresAtLocalInput } from '../../utils/rescuePush';

/**
 * 目标推送表单面板
 */
export default function TargetPushPanel({
  organizations,
  groups,
  users,
  missions = [],
  targetForm,
  setTargetForm,
  handleMultiSelect,
  selectAll,
  clearSelection,
  filterGroupsByOrg,
  filterUsersByGroup,
  handleFormChange,
  handleCoordinatePaste,
  handleCoordinateParse,
  handleMapLinkChange,
  handleMapLinkParse,
  mapLinkParsing,
  handleTargetPush,
  targetLoading,
  clearAllTargets,
  targetResult,
  embedded = false
}) {
  return (
    <>
            <div
        style={{
          display: 'flex',
          gap: 12,
          marginBottom: 12,
          flexWrap: 'wrap',
          alignItems: 'flex-start'
        }}
      >
        <div style={{ flex: '1 1 160px', minWidth: 0 }}>
          <MultiSelectDropdown
            label="组织"
            options={organizations}
            selectedValues={targetForm.org_names}
            onSelectionChange={handleMultiSelect}
            formType="target"
            field="org_names"
            disabled={targetForm.to_all || !!targetForm.mission_id}
            onSelectAll={selectAll}
            onClearAll={clearSelection}
            style={{ marginBottom: 0 }}
          />
        </div>
        <div style={{ flex: '1 1 160px', minWidth: 0 }}>
          <MultiSelectDropdown
            label="小组"
            options={groups}
            selectedValues={targetForm.group_names}
            onSelectionChange={handleMultiSelect}
            formType="target"
            field="group_names"
            disabled={targetForm.to_all || !!targetForm.mission_id}
            cascadeFilter={filterGroupsByOrg}
            parentField="org_names"
            parentValues={targetForm.org_names}
            onSelectAll={selectAll}
            onClearAll={clearSelection}
            style={{ marginBottom: 0 }}
          />
        </div>
      </div>
      
      <div
        style={{
          display: 'flex',
          gap: 12,
          marginBottom: 12,
          flexWrap: 'wrap',
          alignItems: 'flex-start'
        }}
      >
        <div
          style={{
            flex: '1 1 160px',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
          }}
        >
          <label
            style={{
              flex: '0 0 auto',
              margin: 0,
              fontSize: 14,
              fontWeight: 500,
              whiteSpace: 'nowrap',
              lineHeight: '36px'
            }}
          >
            任务：
          </label>
          <select
            name="mission_id"
            value={targetForm.mission_id || ''}
            disabled={targetForm.to_all}
            onChange={(e) => {
              const missionId = e.target.value;
              setTargetForm((f) => ({
                ...f,
                mission_id: missionId,
                mission_group_id: '',
                mission_group_name: '',
                ...(missionId
                  ? { to_all: false, org_names: [], group_names: [], user_names: [] }
                  : {})
              }));
            }}
            style={{
              flex: '1 1 120px',
              minWidth: 0,
              width: 'auto',
              padding: '8px 12px',
              border: '1px solid #ddd',
              borderRadius: 4,
              fontSize: 14,
              background: targetForm.to_all ? '#f5f5f5' : '#fff',
              minHeight: 36,
              opacity: targetForm.to_all ? 0.6 : 1
            }}
          >
            <option value="">不选（用上方组织/小组）</option>
            {(missions || []).map((m) => (
              <option key={m.id} value={m.id}>
                {m.name || m.id}
              </option>
            ))}
          </select>
        </div>
        <div
          style={{
            flex: '1 1 160px',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
          }}
        >
          <label
            style={{
              flex: '0 0 auto',
              margin: 0,
              fontSize: 14,
              fontWeight: 500,
              whiteSpace: 'nowrap',
              lineHeight: '36px'
            }}
          >
            小组：
          </label>
          <select
            name="mission_group_id"
            value={targetForm.mission_group_id || ''}
            disabled={!targetForm.mission_id || targetForm.to_all}
            onChange={(e) => {
              const gid = e.target.value;
              const mission = (missions || []).find((m) => String(m.id) === String(targetForm.mission_id));
              const g = (mission?.groups || []).find((x) => String(x.id) === String(gid));
              setTargetForm((f) => ({
                ...f,
                mission_group_id: gid,
                mission_group_name: g?.name || ''
              }));
            }}
            style={{
              flex: '1 1 120px',
              minWidth: 0,
              width: 'auto',
              padding: '8px 12px',
              border: '1px solid #ddd',
              borderRadius: 4,
              fontSize: 14,
              background: !targetForm.mission_id || targetForm.to_all ? '#f5f5f5' : '#fff',
              minHeight: 36,
              opacity: !targetForm.mission_id || targetForm.to_all ? 0.6 : 1
            }}
          >
            <option value="">{targetForm.mission_id ? '整任务全部队员' : '请先选任务'}</option>
            {((missions || []).find((m) => String(m.id) === String(targetForm.mission_id))?.groups || []).map((g) => (
              <option key={g.id} value={g.id}>
                {g.name || g.id}
              </option>
            ))}
          </select>
        </div>
      </div>
      {targetForm.mission_id ? (
        <div style={{ fontSize: 12, color: '#1565c0', marginTop: -8, marginBottom: 12 }}>
          已选任务：仅推送给该任务名册（或任务小组）内队员；上方组织/小组/用户已停用。
        </div>
      ) : null}

      <MultiSelectDropdown
        label="用户"
        options={users}
        selectedValues={targetForm.user_names}
        onSelectionChange={handleMultiSelect}
        formType="target"
        field="user_names"
        disabled={targetForm.to_all || !!targetForm.mission_id}
        cascadeFilter={filterUsersByGroup}
        parentField="group_names"
        parentValues={targetForm.group_names}
        onSelectAll={selectAll}
        onClearAll={clearSelection}
      />
      <div style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ minWidth: '40px', fontSize: 14 }}>纬度：</label>
          <input
            name="lat"
            value={targetForm.lat}
            onChange={handleFormChange(targetForm, setTargetForm)}
            onPaste={(e) => handleCoordinatePaste(e, 'lat')}
            style={{
              flex: 1,
              minWidth: 0,
              padding: '6px 8px',
              border: '1px solid #ddd',
              borderRadius: 4,
              fontSize: 14,
              background: '#fff'
            }}
            placeholder="支持多种格式，可粘贴坐标"
          />
          <label style={{ minWidth: '40px', fontSize: 14, marginLeft: 8 }}>经度：</label>
          <input
            name="lng"
            value={targetForm.lng}
            onChange={handleFormChange(targetForm, setTargetForm)}
            onPaste={(e) => handleCoordinatePaste(e, 'lng')}
            style={{
              flex: 1,
              minWidth: 0,
              padding: '6px 8px',
              border: '1px solid #ddd',
              borderRadius: 4,
              fontSize: 14,
              background: '#fff'
            }}
            placeholder="支持多种格式，可粘贴坐标"
          />
          <button
            type="button"
            onClick={handleCoordinateParse}
            style={{
              padding: '6px 12px',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 12,
              whiteSpace: 'nowrap'
            }}
            title="识别并分隔经纬度"
          >
            识别
          </button>
        </div>
        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
          💡 可直接粘贴坐标（如：119.145600,28.080150）后点「识别」；也可用下方地图链接解析自动填入
        </div>
      </div>

      <div style={{ marginBottom: 12 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            marginBottom: 6
          }}
        >
          <label style={{ margin: 0 }}>地图链接：</label>
          <button
            type="button"
            onClick={() => handleMapLinkParse()}
            disabled={mapLinkParsing || !targetForm.map_link.trim()}
            style={{
              padding: '4px 12px',
              background: mapLinkParsing || !targetForm.map_link.trim() ? '#90caf9' : '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: mapLinkParsing || !targetForm.map_link.trim() ? 'not-allowed' : 'pointer',
              fontSize: 12,
              whiteSpace: 'nowrap'
            }}
            title="与坐标转换工具相同：解析百度/高德等地图链接为 WGS84"
          >
            {mapLinkParsing ? '解析中...' : '解析链接'}
          </button>
        </div>
        <textarea
          name="map_link"
          value={targetForm.map_link}
          onChange={handleMapLinkChange}
          rows={3}
          style={{
            width: '100%',
            padding: '6px 8px',
            border: '1px solid #ddd',
            borderRadius: 4,
            fontSize: 14,
            resize: 'vertical',
            fontFamily: 'inherit',
            background: '#fff'
          }}
          placeholder={
            '支持直接粘贴链接，或「地址文字+链接」混合内容，例如：\n城东四路220号\n中国, 浙江省, 丽水市, 龙泉市\nhttps://surl.amap.com/xxx'
          }
        />
        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
          与「坐标转换 → 地图链接解析」相同接口；解析后将 WGS84 填入上方纬度/经度，仍可手动改或重新「识别」
        </div>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label>图标：</label>
        <select name="icon" value={targetForm.icon} onChange={handleFormChange(targetForm, setTargetForm)} style={{ width: '100%' }}>
          {ICONS.map((i) => (
            <option key={i.value} value={i.value}>
              {i.label}
            </option>
          ))}
        </select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label>消息：</label>
        <input name="message" value={targetForm.message} onChange={handleFormChange(targetForm, setTargetForm)} style={{ width: '100%' }} />
      </div>
            <div style={{ marginBottom: 12 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
          }}
        >
          <label style={{ margin: 0, whiteSpace: 'nowrap', fontSize: 14 }}>有效时间：</label>
          <input
            type="datetime-local"
            name="expires_at"
            value={targetForm.expires_at || defaultExpiresAtLocalInput()}
            onChange={handleFormChange(targetForm, setTargetForm)}
            style={{
              flex: '1 1 200px',
              minWidth: 0,
              maxWidth: 280,
              padding: '6px 8px',
              border: '1px solid #ddd',
              borderRadius: 4,
              fontSize: 14,
              background: '#fff'
            }}
          />
          <button
            type="button"
            onClick={() => setTargetForm((f) => ({ ...f, expires_at: defaultExpiresAtLocalInput() }))}
            style={{
              padding: '6px 12px',
              fontSize: 12,
              fontWeight: 600,
              border: '1px solid #1565c0',
              borderRadius: 4,
              background: '#1565c0',
              color: '#fff',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              flexShrink: 0
            }}
            title="重置为当前时间 + 24 小时"
          >
            默认24小时
          </button>
        </div>
        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
          过期后不再作为活跃目标展示（历史仍可查）；默认当前时间起 24 小时，可自定义日期与时间。
        </div>
      </div>
<div style={{ marginBottom: 12 }}>
        <label>紧急程度：</label>
        <select name="level" value={targetForm.level} onChange={handleFormChange(targetForm, setTargetForm)} style={{ width: '60%' }}>
          <option value="普通">普通</option>
          <option value="紧急">紧急</option>
        </select>
        <label style={{ marginLeft: 12 }}>
          <input
            type="checkbox"
            name="to_all"
            checked={targetForm.to_all}
            onChange={(e) => {
              const checked = e.target.checked;
              setTargetForm((f) => ({
                ...f,
                to_all: checked,
                org_names: checked ? [] : f.org_names,
                group_names: checked ? [] : f.group_names,
                user_names: checked ? [] : f.user_names,
                mission_id: checked ? '' : f.mission_id,
                mission_group_id: checked ? '' : f.mission_group_id,
                mission_group_name: checked ? '' : f.mission_group_name
              }));
            }}
          />{' '}
          推送给所有人
        </label>
      </div>
      <div style={{ marginBottom: 18 }}>
        <button
          onClick={handleTargetPush}
          disabled={targetLoading}
          style={{ padding: '8px 32px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 500 }}
        >
          {targetLoading ? '推送中...' : '发送目标'}
        </button>
        <button
          onClick={clearAllTargets}
          style={{ padding: '8px 16px', background: '#f44336', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 500, marginLeft: 8 }}
        >
          {embedded ? '取消打点' : '清理目标'}
        </button>
        {targetResult && (
          <span style={{ marginLeft: 16, color: targetResult.success ? 'green' : 'red' }}>{targetResult.msg}</span>
        )}
      </div>
      {!embedded && (
      <div style={{ fontSize: 13, color: '#888' }}>
        经纬度格式示例：31.12035 或 31°12'42" 或 31°10.335'
        <br />
        支持地图选点，点击右侧地图自动填充经纬度。
        <br />
        点击地图上的队员图标可自动填充坐标和姓名。
      </div>
      )}
    </>
  );
}
